import DOMPurify from 'dompurify';

/** Inline styles from CMS often fix light-theme text/background and break dark mode. */
const STYLE_PROPS_TO_STRIP = new Set([
  'color',
  'background',
  'background-color',
  'background-image',
  '-webkit-text-fill-color',
]);

function filterConsentStyleAttribute(raw: string): string | null {
  const kept = raw
    .split(';')
    .map((part) => part.trim())
    .filter((part) => {
      const colon = part.indexOf(':');
      if (colon <= 0) return false;
      const prop = part.slice(0, colon).trim().toLowerCase();
      if (STYLE_PROPS_TO_STRIP.has(prop)) return false;
      if (prop.startsWith('background-')) return false;
      return true;
    })
    .join('; ')
    .trim();
  return kept.length > 0 ? kept : null;
}

let consentStyleHookRegistered = false;

function ensureConsentStyleHook(): void {
  if (consentStyleHookRegistered) return;
  consentStyleHookRegistered = true;
  DOMPurify.addHook('uponSanitizeAttribute', (_node, data) => {
    if (data.attrName !== 'style' || !data.attrValue?.trim()) return;
    const next = filterConsentStyleAttribute(data.attrValue);
    if (next === null) {
      data.keepAttr = false;
    } else {
      data.attrValue = next;
    }
  });
}

/** Rich consent text from SharePoint: allow links and basic formatting. */
export function sanitizeConsentHtml(html: string): string {
  ensureConsentStyleHook();
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['a', 'b', 'i', 'em', 'strong', 'p', 'br', 'ul', 'ol', 'li', 'span', 'div', 'u'],
    ALLOWED_ATTR: ['href', 'title', 'target', 'rel', 'class', 'style'],
  });
}
